@if (resource) {
  <div class="option">
    <div class="option-section">
      <span>{{ resource.label }}</span>
      @if (resourceStatus) {
        <span>{{ resourceStatus.price + "kr" }}</span>
      }
    </div>
    <div class="option-section">
      @if (resourceStatus) {
        <span
          [ngClass]="{'availability': true, 'warning': (bookedResources || 0) > (resourceStatus.qty || 0)}">
          Bokade platser:
          {{ bookedResources + "/" + resourceStatus.qty }}
          @if ((bookedResources || 0) > (resourceStatus.qty || 0)) {
            <mat-icon
            matTooltip="Kapacitet överstigen">warning</mat-icon>
          }
        </span>
      }
    </div>
  </div>
}